/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import $ from 'jquery';
import LocalizedStrings from 'react-localization';
import 'bootstrap-select';
// import AdvBanner from './banners/AdvBanner';
// import GiftBanner from './banners/GiftBanner';
// import Pagination from './Pagination';
import InsuranceItem from './InsuranceItem';
import ErrorIndicator from './ErrorIndicator';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom'

class InsuranceList extends Component {
  state = {
    insurances: [],
    insurancesShow: [],
    page: 1,
    totalPages: 3,
  };

  componentDidMount() {
    const { page } = this.state;

    this.setState({
      insurances: localStorage.getItem('offers') ? JSON.parse(localStorage.getItem('offers')).offers : [],
      insurancesShow: localStorage.getItem('offers') ? JSON.parse(localStorage.getItem('offers')).offers.filter((el, index) => index < page * 9) : []
    });

    $('select').selectpicker('refresh');
    $(() => {
      if (window.innerWidth <= 760) {
        $('#kasco_offer-parameters .left-block').click(() => {
          $('#main').addClass('ov-hidden');
          $('#main').addClass('kasco_offer-parameters');
          $('#kasco_offer-parameters .right-block').addClass('open');
        });
        $('#kasco_offer-parameters .mob-close').click(() => {
          $('#main').removeClass('ov-hidden');
          $('#kasco_offer-parameters .right-block').removeClass('open');
          $('#main').removeClass('kasco_offer-parameters');
        });
      }
    });
  }

  handlePagination = (e) => {
    this.setState({ page: parseInt(e.target.id, 10) });
  };

  prevPage = () => {
    if (this.state.page !== 1) {
      this.setState(({ page }) => {
        return {
          page: page - 1
        }
      });
    }
  };

  nextPage = () => {
    const { page, totalPages } = this.state;
    if (page !== totalPages) {
      this.setState(({ page }) => {
        return {
          page: page + 1
        }
      });
    }
  };

  render() {
    const { insurancesShow, insurances } = this.state;
    const { locale, location: { search } } = this.props;

    const values = queryString.parse(search);
    const url = `?step=2&car=${values.car}&model=${values.model}&year=${values.year}&fuel=${values.fuel}&transmission=${values.transmission}&region=${values.region}&city=${values.city}${values.engine ? `&engine=${values.engine}` : ''}&distance=${values.distance}&number=${values.number}&price=${values.price}&drivers=${values.drivers}&age=${values.age}&experience=${values.experience}${values.taxi ? `&taxi=${values.taxi}` : ''}${values.credit ? `&credit=${values.credit}` : ''}`;

    const strings = new LocalizedStrings({
      ru: {
        sorted: 'Сортировать по:',
        rating: 'Рейтинг компаний',
        sale: 'Акции',
        popular: 'По популярности',
        cheep: 'Сначала дешевле',
        exp: 'Сначала дороже',
        offers: 'предложений',
        title: 'К сожалению, по Вашему запросу предложений не найдено',
        text: 'Попробуйте изменить параметры запроса',
        btn: 'Изменить параметры',
      },
      ua: {
        sorted: 'Сортувати за:',
        rating: 'Рейтинг компаній',
        sale: 'Акції',
        popular: 'За популярністю',
        cheep: 'Спочатку дешевше',
        exp: 'Спочатку дорожче',
        offers: 'пропозицій',
        title: 'На жаль, по Вашому запиту пропозицій не знайдено',
        text: 'Спробуйте змінити параметри запиту',
        btn: 'Змінити параметри',
      },
    });

    strings.setLanguage(locale);

    const items = insurancesShow.map((el, index) => (
      <InsuranceItem
        key={index}
        id={el.insuranceCompanyCode}
        // img="../img/8.png"
        type="КАСКО"
        name={el.insuranceCompanyName}
        packages={[el.light, el.popular, el.premium]}
        locale={locale}
        logoList={[el.insuranceCompanyLogoPng, el.insuranceCompanyLogoWebp]}
      // with_cashback={{ status: false }}
      // mark="4.5"
      // marks_count="154"
      // reviews="541"
      />
    ));
    const group1 = items.filter((el, index) => index < 3);
    const group2 = items.filter((el, index) => index < 6 && index > 2);
    const group3 = items.filter((el, index) => index > 5);

    if (!insurances.length) {
      return (
        <div className="error-offers flex flex_j-center banner-block">
          <ErrorIndicator
            title={strings.title}
            text={strings.text}
            btn={strings.btn}
            url={url}
            locale={locale}
          />
        </div>
      )
    }

    return (
      <div className="left-block">
        <div className="filter flex flex_j-flex-end">
          {/*<div className="form-group form-select without-search">*/}
          {/*  <label>{strings.sorted}</label>*/}
          {/*  <select className="selectpicker" title={strings.rating}>*/}
          {/*    <option>{strings.rating}</option>*/}
          {/*    <option>{strings.sale}</option>*/}
          {/*    <option>{strings.popular}</option>*/}
          {/*    <option>{strings.cheep}</option>*/}
          {/*    <option>{strings.exp}</option>*/}
          {/*  </select>*/}
          {/*</div>*/}
          <div className="sum">
            <p>{strings.offers}: {insurances.length}</p>
          </div>
        </div>
        {group1}
        {/*<AdvBanner locale={locale} />*/}
        {group2}
        {/*<GiftBanner locale={locale} />*/}
        {group3}
        {/*<Pagination*/}
        {/*  pages={this.state.totalPages}*/}
        {/*  activePage={this.state.page}*/}
        {/*  handlePagination={this.handlePagination}*/}
        {/*  nextPage={this.nextPage}*/}
        {/*  prevPage={this.prevPage}*/}
        {/*/>*/}
      </div>
    );
  }
}

export default withRouter(InsuranceList);
